<div class="dropdown always-enabled">
  <button class="btn"
          [ngClass]="selectedOptions.length > 0 || deselectedOptions.length > 0 ? 'btn-danger' : 'btn-outline-info'"
          type="button"
          id="dropdownMenuButton" data-bs-toggle="dropdown" data-bs-reference="parent" aria-haspopup="true"
          aria-expanded="false">
    <span class="fa fa-filter m-0"></span>
  </button>
  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" (click)="$event.stopPropagation()">
    <div class="p-3" style="min-width: 550px">
      <div class="row g-0">
        @for (option of options; track option; let index = $index) {
          <div class="col-6">
            <div class="row narrow-gutters align-items-center">
              <div class="col text-end">
                <span class="small" style="cursor: pointer;"
                      (click)="isToggled(option) ? reset(option) : toggleOn(option)">
                  {{ phaseDisplayName(option) }}
                </span>
              </div>
              <div class="col-auto" style="min-width: 4rem">
                <div class="btn-group">
                  <button type="button" class="btn px-2 py-1" style="font-size: 0.7rem;"
                          (click)="toggleOn(option)"
                          [ngClass]="isOn(option) ? 'btn-success' : 'btn-outline-success'">
                    <span class="fa fa-plus"></span>
                  </button>
                  <button type="button" class="btn px-0 py-0 btn-outline-dark" style="min-width: 1.5rem">
                    <span [title]="count(option)" class="d-inline-block small" style="min-width: 2rem">
                      {{ count(option) | largeNumberFormat }}
                    </span>
                  </button>
                  <button type="button" class="btn px-2 py-1" style="font-size: 0.7rem;"
                          (click)="toggleOff(option)"
                          [ngClass]="isOff(option) ? 'btn-danger' : 'btn-outline-danger'">
                    <span class="fa fa-minus"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        }

        @if (selectedOptions.length > 0 || deselectedOptions.length > 0) {
          <div class="col-auto ms-auto mt-2">
            <button class="me-1 p-0 btn btn-secondary border-0 bg-transparent text-secondary" (click)="resetAll()"
                    style="font-size: 0.8rem;">
              <span class="fa fa-ban me-1"></span> Clear filters
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
